import VideoTimeLine from './VideoTimeLine';
import Video from './Video';

import './video.scss';

export {
  VideoTimeLine
};

export default Video;